export default __webpack_public_path__ + "static/4-1b4b51d88578b369e25fbc7ddbf12387.jpeg";